import type { CompanyProfile } from '@/lib/authApi';

/**
 * Os três perfis de atuação, com tudo o que a interface precisa exibir.
 *
 * Um lugar só: a landing usa para os botões de cadastro, e a tela de cadastro
 * usa para mostrar o perfil escolhido e mandá-lo à API. O <c>slug</c> é o que
 * viaja na URL (`/cadastro?perfil=fornecedor`), em português, porque é o que o
 * usuário vê; o <c>value</c> é o nome do enum do backend.
 */
export interface ProfileMeta {
  /** Nome do enum no backend. */
  readonly value: CompanyProfile;
  /** Identificador em português usado na URL. */
  readonly slug: string;
  /** Rótulo curto: "Comprador". */
  readonly label: string;
  /** Texto do botão da landing: "Sou comprador". */
  readonly cta: string;
  /** Uma linha sobre o que esse perfil faz na plataforma. */
  readonly tagline: string;
}

// Record com chave na união fechada: indexar por CompanyProfile devolve
// ProfileMeta, sem o `| undefined` que o acesso a array traria.
const META: Record<CompanyProfile, ProfileMeta> = {
  Buyer: {
    value: 'Buyer',
    slug: 'comprador',
    label: 'Comprador',
    cta: 'Sou comprador',
    tagline: 'Construtoras e empreiteiras que compram material e contratam serviço.',
  },
  Supplier: {
    value: 'Supplier',
    slug: 'fornecedor',
    label: 'Fornecedor',
    cta: 'Sou fornecedor',
    tagline: 'Distribuidoras e prestadores que vendem para a obra.',
  },
  Hybrid: {
    value: 'Hybrid',
    slug: 'ambos',
    label: 'Comprador e fornecedor',
    cta: 'Atuo dos dois lados',
    tagline: 'Quem compra e também fornece — o cadastro cobre os dois papéis.',
  },
};

export const PROFILES: readonly ProfileMeta[] = [META.Buyer, META.Supplier, META.Hybrid];

export function profileFromSlug(slug: string | null | undefined): ProfileMeta | undefined {
  return PROFILES.find((profile) => profile.slug === slug);
}

export function profileByValue(value: CompanyProfile): ProfileMeta {
  return META[value];
}
